import React, { useState } from 'react';
import { VideoUploadIcon } from '@/components/common/icon';
import { message, Upload } from 'antd';
import axios from 'axios';
import { feedbackMediaUploadApi } from '@/apis/ordeApi';
import { Loading } from 'aha-components';

interface Props {
  onChange: Function;
  text?: string;
  orderId?: string;
}

const UploadVideos: React.FC<Props> = ({ onChange, text }) => {
  const [loading, setLoading] = useState(false);
  const getAwsUrlAndUpload = async (file: any) => {
    setLoading(true);

    try {
      // 大小大于100MB
      if (file.size > 100 * 1024 * 1024) {
        message.error('The file size cannot exceed 100MB!');
        return Promise.reject(new Error('The file size cannot exceed 100MB!'));
      }
      const res = await feedbackMediaUploadApi({ keys: [file.name] });
      const presignedUrl = res?.[0]?.presignedUrl;
      const publicUrl = res?.[0]?.publicUrl;
      const options = {
        headers: {
          'Content-Type': file.type
        }
      };
      await axios.put(presignedUrl, file, options);
      // 只回传本次新上传的 URL，避免 answer 被清空后旧媒体从本地 fileList 回显
      onChange([publicUrl]);

      setTimeout(() => {
        return Promise.resolve(presignedUrl);
      }, 0);
    } catch (error: any) {
      console.error(error);
      message.error(`${error?.message} || Failed to upload image`);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <Loading width={20} height={20} color="#000" />;
  }

  return (
    <Upload
      listType="picture"
      accept=".mp4,.avi,.mov,.mkv,.webm,.flv,.wmv,.3gp,.rm,.ogv,.mpg,.mpeg"
      showUploadList={false}
      className="avatar-uploader"
      beforeUpload={getAwsUrlAndUpload}
      disabled={loading}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer'
        }}
      >
        <VideoUploadIcon />
        {text && <span style={{ marginLeft: '8px' }}>{text}</span>}
      </div>
    </Upload>
  );
};

export default UploadVideos;
